module.exports = "https://cdn.thelire.com/ins/resource/icon_line_back@3x.9f8055296fb12eec248f3e9dc92e730f.png";